<template>
  <div class="left-menu">
    <ul class="nav-list">
      <li
        v-for="(item, index) in menuItems"
        :key="index"
        class="nav-item noselect"
        :class="{ selected: item.value === selectedStatus }"
        @click="updateStatusFilter(item.value)"
      >
        {{ item.displayText }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    menuItems: {
      type: Array,
      required: true
    },
    selectedStatus: {
      type: String,
      required: false,
      default: ""
    }
  },
  methods: {
    updateStatusFilter(status) {
      this.$emit("selectedStatusFilter", status);
    }
  }
};
</script>
<style lang="scss">
@import "@/assets/style/css/generic-variables.scss";
.left-menu {
  color: $subSidenavFontColor;
  background-color: $subSidenavBackgroundColor;
  width: 240px;
  min-width: 170px;
  font-weight: 700;
  font-size: 12px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.35);
  ul {
    margin-top: 0px;
    padding: 0px;
    li {
      padding: 10px 25px;
      width: 100%;
      border-bottom: 1px solid black;
      cursor: pointer;
      &.nav-item:hover {
        background-color: $subSidenavHover;
      }
      &.selected {
        background-color: $subSidenavSelected;
        -moz-box-shadow: inset 0 0 5px #000000;
        -webkit-box-shadow: inset 0 0 5px #000000;
        box-shadow: inset 0 0 5px #000000;
        color: $subSidenavFontColorSelected;
      }
    }
  }
}
</style>
